import { MapPin } from "lucide-react";
import { SectionHead } from "@/components/SectionHead";
import { useLang } from "@/LanguageContext";
import { TOWNS } from "@/data/site";

export const ServiceArea = () => {
  const { t, town } = useLang();
  return (
  <section id="area" data-testid="area-section" className="border-b border-steel-700 bg-steel-900 py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
      <SectionHead
        label={t.area.label}
        title={t.area.title}
        sub={t.area.sub}
        testid="area-head"
      />

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
        <ul data-testid="towns-list" className="lg:col-span-2 grid grid-cols-1 gap-px self-start bg-steel-700 sm:grid-cols-3">
          {TOWNS.map((name) => (
            <li
              key={name}
              data-testid={`town-${name.toLowerCase().replace(/\s+/g, "-")}`}
              className="flex items-center gap-2 bg-steel-900 px-3 py-4 font-head text-base font-semibold uppercase tracking-wide text-steel-50 sm:text-lg"
            >
              <MapPin size={15} className="shrink-0 text-forge" />
              {town(name)}
            </li>
          ))}
        </ul>

        <div className="lg:col-span-3 overflow-hidden rounded-sm border border-steel-700">
          <iframe
            title={t.area.mapTitle}
            data-testid="area-map"
            src="https://www.openstreetmap.org/export/embed.html?bbox=-121.05%2C36.35%2C-119.85%2C37.35&amp;layer=mapnik&amp;marker=36.8588%2C-120.4560"
            className="h-[340px] w-full grayscale-[35%] md:h-[440px]"
            loading="lazy"
            style={{ border: 0 }}
          />
        </div>
      </div>
    </div>
  </section>
  );
};
